<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      id="Combined Shape"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.5602 1.16532C12.1888 0.922842 11.6874 0.947099 11.3419 1.23809L0.341907 10.5032L0.252589 10.5884C-0.0780509 10.9458 -0.0884143 11.493 0.24709 11.8629L0.335507 11.9489C0.706465 12.2676 1.27428 12.2775 1.65812 11.9542L3 10.824V22.0364L3.00673 22.1487C3.06449 22.628 3.48716 23 4 23H10L10.1166 22.9935C10.614 22.9379 11 22.5306 11 22.0364L10.999 15.5325H12.999L13 22.0364L13.0067 22.1487C13.0645 22.628 13.4872 23 14 23H20.0008L20.1174 22.9935C20.6147 22.9379 21.0008 22.5306 21.0008 22.0364V10.824L22.3427 11.9543L22.4423 12.0282C22.8541 12.2961 23.4182 12.2327 23.7537 11.8628C24.1172 11.4621 24.0747 10.8534 23.6588 10.5031L12.6581 1.23807L12.5602 1.16532ZM19.0007 9.13955L12 3.24333L4.99997 9.13942L4.999 21.0724H8.999L9 14.5689C9 14.0748 9.38604 13.6675 9.88338 13.6118L10 13.6053H14C14.5128 13.6053 14.9355 13.9773 14.9933 14.4566L15 14.5689L14.999 21.0724H19L19.0007 9.13955Z"
      fill="#4B4C52"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'HomeIconOutline',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
